// Минимальный ZIP без сжатия (store): хватает для пачки PNG, которые и так сжаты.
// files: [{ name: 'a.png', data: Uint8Array }] → Blob application/zip

const CRC_TABLE = (() => {
	const table = new Uint32Array(256)
	for (let n = 0; n < 256; n++) {
		let c = n
		for (let k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1
		table[n] = c >>> 0
	}
	return table
})()

function crc32(data) {
	let crc = 0xFFFFFFFF
	for (let i = 0; i < data.length; i++) crc = CRC_TABLE[(crc ^ data[i]) & 0xFF] ^ (crc >>> 8)
	return (crc ^ 0xFFFFFFFF) >>> 0
}

function dosDateTime(date = new Date()) {
	const time = (date.getHours() << 11) | (date.getMinutes() << 5) | Math.floor(date.getSeconds() / 2)
	const day = ((date.getFullYear() - 1980) << 9) | ((date.getMonth() + 1) << 5) | date.getDate()
	return { time, day }
}

export function createZip(files) {
	const encoder = new TextEncoder()
	const { time, day } = dosDateTime()
	const parts = []
	const central = []
	let offset = 0

	files.forEach((file) => {
		const name = encoder.encode(file.name)
		const data = file.data
		const crc = crc32(data)

		// 0x0800 — имя в UTF-8, иначе кириллица в названиях зала/стола побьётся
		const local = new DataView(new ArrayBuffer(30))
		local.setUint32(0, 0x04034B50, true)
		local.setUint16(4, 20, true)
		local.setUint16(6, 0x0800, true)
		local.setUint16(8, 0, true)
		local.setUint16(10, time, true)
		local.setUint16(12, day, true)
		local.setUint32(14, crc, true)
		local.setUint32(18, data.length, true)
		local.setUint32(22, data.length, true)
		local.setUint16(26, name.length, true)
		local.setUint16(28, 0, true)
		parts.push(new Uint8Array(local.buffer), name, data)

		const entry = new DataView(new ArrayBuffer(46))
		entry.setUint32(0, 0x02014B50, true)
		entry.setUint16(4, 20, true)
		entry.setUint16(6, 20, true)
		entry.setUint16(8, 0x0800, true)
		entry.setUint16(10, 0, true)
		entry.setUint16(12, time, true)
		entry.setUint16(14, day, true)
		entry.setUint32(16, crc, true)
		entry.setUint32(20, data.length, true)
		entry.setUint32(24, data.length, true)
		entry.setUint16(28, name.length, true)
		entry.setUint32(42, offset, true)
		central.push(new Uint8Array(entry.buffer), name)

		offset += 30 + name.length + data.length
	})

	const centralSize = central.reduce((sum, item) => sum + item.length, 0)
	const end = new DataView(new ArrayBuffer(22))
	end.setUint32(0, 0x06054B50, true)
	end.setUint16(8, files.length, true)
	end.setUint16(10, files.length, true)
	end.setUint32(12, centralSize, true)
	end.setUint32(16, offset, true)

	return new Blob([...parts, ...central, new Uint8Array(end.buffer)], { type: 'application/zip' })
}

export function dataUrlToBytes(dataUrl) {
	const binary = atob(dataUrl.split(',')[1])
	const bytes = new Uint8Array(binary.length)
	for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
	return bytes
}
